import { Link } from "react-router-dom";

export default function Footer(prop = 'none'){

	function handleReload(){
		window.location.reload();
		return;
	}
    return(
        <>
        	<div className="site-footer">
		<div className="inner first">
			<div className="container">
				<div className="row">
					<div className="col-md-6 col-lg-4">
						<div className="widget">
							<h3 className="heading">About BioUniverse</h3>
							<p>
							Welcome to the mesmerizing world of "<span style={{color: "#1A374D", fontWeight: 600}}>BioUniverse</span>" – an enchanting gateway to explore the wonders of the animal kingdom and beyond. Here, every page is a vibrant tapestry woven with fascinating facts, captivating images, and intriguing stories about the diverse inhabitants that call our planet home.
							</p>
						</div>
						<div className="widget">
							<ul className="list-unstyled social">
								<li><Link to="https://www.instagram.com/vishal.webengg/" target="_blank"><span className="icon-instagram"></span></Link></li>
								<li><Link to="https://www.linkedin.com/in/vishal-4a3724289" target="_blank"><span className="icon-linkedin"></span></Link></li>
								<li><Link to="https://twitter.com/Vishal_webengg" target="_blank"><span className="icon-twitter"></span></Link></li>
								<li><Link to="https://github.com/vishal257" target="_blank"><span className="icon-github"></span></Link></li>
							</ul>
						</div>
					</div>
					<div className="col-md-6 col-lg-2 pl-lg-5">
						<div className="widget">
							<h3 className="heading">Pages</h3>
							<ul className="links list-unstyled">
								<li><Link to="/register">Login</Link></li>
								<li><Link to='/about'>About</Link></li>
								<li><Link to="/contact">Contact</Link></li>
							</ul>
						</div>
					</div>
					<div className="col-md-6 col-lg-2">
						<div className="widget">
							<h3 className="heading">Resources</h3>
							<ul className="links list-unstyled">
								<li><Link to="/article">Article</Link></li>
								<li><Link to="/gallery">Gallery</Link></li>
								<li><Link to="/home" onClick={'home'=== prop.current ? handleReload : ''}>Catergories</Link></li>
							</ul>
						</div>
					</div>
					<div className="col-md-6 col-lg-4">
						<div className="widget">
							<h3 className="heading">Contact</h3>
							<ul className="list-unstyled quick-info links">
								<li className="email"><a href="mailto:vishal.webengg+biouniverse@gmail.com" className="footer_form_mail" style={{color:'#777777'}}>vishal.webengg@gmail.com</a></li>
								<li className="phone">+91 62831 - 27981</li>
								<li className="address">Punjab, India</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>



		<div className="inner dark">
			<div className="container">
				<div className="row text-center">
					<div className="col-md-8 mb-3 mb-md-0 mx-auto">
						<p>Copyright &copy; All Rights Reserved. &mdash; More from <a href="https://vishal257.github.io/portfolio/index.html" className="link-highlight" target="_blank">Vishal</a>
						</p>
					</div>
					
				</div>
			</div>
		</div>
	</div>
        </>
    );
}